import React from "react";
import ScrollableAnchor from "react-scrollable-anchor";

const RehaSportSection = () => (
    <ScrollableAnchor id="reha">
      <section className="content-section bg-dark text-white text-center animatedParent animateOnce" data-sequence='500' data-appear-top-offset='-300'>
        <div className="container">
          <div className="content-section-heading text-center">
            <h3 className="text-secondary mb-0">Info</h3>
            <h2 className="mb-5">Reha Sport</h2>
          </div>
          <div className="animated fadeInDownShort" data-id="1">
            <p className="textJustify">Rehabilitationssport (Reha-Sport) stellt eine ergänzende Maßnahme im Rahmen der medizinischen
              Rehabilitation und zur Förderung der Teilhabe am Arbeitsleben dar. Reha-Sport ist gesetzlich verankert und
              wird zeitlich befristet von den Rehabilitationsträgern finanziert. Die positiven Auswirkungen auf die
              Gesundheit sind unumstritten: Alltagsbeschwerden werden vermindert und krankheitsbedingten Folgeschäden
              kann entgegengewirkt werden. Das Risiko, an Folgeerkrankungen zu erleiden, sinkt.</p>
          </div>
        </div>
      </section>
    </ScrollableAnchor>
);

export default RehaSportSection;



// WEBPACK FOOTER //
// ./src/courseinfo/sport.js